export enum VideoPlayerType {
  Pitcher = 'pitcher',
  Fire = 'fire',
}

export const getPlaybackRateDefault = (
  type: VideoPlayerType,
  videoSpeed: number | undefined
) => {
  switch (type) {
    case VideoPlayerType.Fire: {
      if (videoSpeed) {
        // the desired default playback for fire videos is slowed down, i.e. output * video's speed should equal 0.5,
        return 0.5 / videoSpeed;
      }

      // ? prior to AM 1.9, all fire videos were uploaded at 0.5x w/o any speed field
      // playing these already-slow at 1x speed gives the desired effect
      return 1;
    }

    case VideoPlayerType.Pitcher:
    default: {
      return 1;
    }
  }
};

export const getPlaybackRateCookieKey = (
  type: VideoPlayerType,
  videoSpeed: number | undefined
) => {
  switch (type) {
    // fire videos have a different key for each upload speed
    case VideoPlayerType.Fire: {
      if (videoSpeed) {
        // ? speed values are expected post AM 1.9 (should be 1 for all cases)
        return `video-playback-rate-${type}-${videoSpeed.toFixed(1)}x`;
      }

      // ? prior to AM 1.9, fire videos had no speed field but were actually uploaded at 0.5x
      return `video-playback-rate-${type}-0.5x`;
    }

    case VideoPlayerType.Pitcher:
    default: {
      return `video-playback-rate-${type}-1.0x`;
    }
  }
};
